import { Injectable, inject } from '@angular/core';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Collection } from '../enums/collection.enum';
import { Event } from '../models/event';
import { map } from 'rxjs/operators';
import { deleteDoc, doc, getDoc, getDocs, onSnapshot, serverTimestamp, setDoc,  } from '@angular/fire/firestore';
import { Firestore, collectionData, collection, where, query, orderBy, limit } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private firestore = inject(Firestore);
  private _auth = inject(Auth);
  private eventsCollection: AngularFirestoreCollection<Event>;
  private currentUser;
  private authSubscription;
  constructor(
    private _firestore: AngularFirestore,
    ) {
    this.eventsCollection = _firestore.collection<Event>(Collection.Events);
    this.authSubscription = onAuthStateChanged(this._auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        this.currentUser = user;
        // ...
      } else {
        // User is signed out
        this.currentUser = null;
      }
    });
  }
  ngOnDestroy(): void {
    if(this.authSubscription) {
      // unsubscribes
      this.authSubscription();
    }
  }
  list(){
    return this.eventsCollection
    .valueChanges({'idField':'id'})
    .pipe(
      map(x => x.map(y => Object.assign(new Event, y))),
    );
  }
  async get(id: string){
    const docRef = doc(this.firestore, Collection.Events, id);
    return await getDoc(docRef);
  }
  getByRace(raceId: string){
    const q = query(
      collection(this.firestore, Collection.Events),
      where('raceId', '==', raceId),
      orderBy('scheduledTime'),
    );
    return collectionData(q)
      .pipe(
        map(x => x.map(y => Object.assign(new Event, y))),
      );
  }
  async add(event: Event) {
    event.owner = this.currentUser.uid;
    event.created = serverTimestamp();
    const newEventRef = doc(collection(this.firestore, Collection.Events));
    event.id = newEventRef.id
    setDoc(newEventRef, event)
    return event.id;
  }
  update(event: Event) {
    event.modified = serverTimestamp();
    event.id = event.id.trim();
    const eventRef = doc(this.firestore, Collection.Events, event.id);
    setDoc(eventRef, Object.assign({}, event), { merge: true })
  }
  async updateReferees(referees: string[], ids: string[]){
    // Get a new write batch
    const batch = this._firestore.firestore.batch();

    // Set referees for each event
    ids.forEach(id => {
      const entryRef = this._firestore.firestore.collection(Collection.Events).doc(id);
      batch.update(entryRef, {referees: referees});
    })

    // Commit the batch
    await batch.commit();
  }
  async deleteBatch(eventIds: string[]){
    // Get a new delete batch
    const batch = this._firestore.firestore.batch();

    // Add result to batch
    eventIds.forEach(id => {
      const entryRef = this._firestore.firestore.collection(Collection.Events).doc(id);
      batch.delete(entryRef);
    })

    // Commit the batch
    await batch.commit();
  }
}
